import React from 'react';
import { FormattedMessage } from 'react-intl';

export const frequentlyAskedQuestions = (
    <FormattedMessage
        id="buy.frequentlyAskedQuestions"
        defaultMessage="Frequently Asked Questions"
    />
);
